import { Component, Input, OnInit } from '@angular/core';
import * as _ from 'lodash';
import { ITaskModel } from 'src/app/shared/interfaces/task-model.interface';
import { ITableCell } from 'src/app/shared/models/table-cell';
import { InstanceService } from '../../services/instance.service';
import { ZoningCodeService } from '../../services/zoning-code.service';

@Component({
    standalone: false,
    selector: 'app-tasks-list',
    templateUrl: './tasks-list.component.html',
    styleUrls: ['./tasks-list.component.scss']
})
export class TasksListComponent implements OnInit {
    // _tasks: ITaskModel[];
    // totalActiveThreadsCount: number = 0;

    // get tasks(): ITaskModel[] {
    //     return this._tasks;
    // }

    // @Input()
    // set tasks(value: ITaskModel[]) {
    //     this._tasks = value;
    //     this.totalActiveThreadsCount = this._tasks.reduce((acc, process) => {
    //         return acc + _.get(process, 'allowedThreadsCount', 0); // May be better to use active threads
    //     }, 0);
    // }

    @Input()
    tasks: ITaskModel[];

    @Input()
    showListBorders: boolean = false;

    @Input()
    showActions: boolean = true;

    @Input()
    showRecalculateButton: boolean = true;

    @Input()
    showClearThreadsButton: boolean = true;

    @Input()
    showStartStopButton: boolean = true;

    @Input()
    showProcessDetailsPopupButton: boolean = false;

    taskColumns: ITableCell[] = [
        { property: 'actualVersion', title: 'Actual Version' },
        { property: 'timeFromStartStr', title: 'Work time' },
        { property: 'progress', title: 'Progress %' },
        { property: 'maxThreadsCount', title: 'Max Threads' }
        // { property: 'allowedThreadsCount', getTitle: this.getThreadsTitle.bind(this) } // May be better to use active threads
    ];

    taskColumnsToDisplay: string[] = [
        'createdAt',
        'instanceName',
        'zoningCodeName',
        'actualVersion',
        'timeFromStartStr',
        'progress',
        'iterationsPerHour',
        'maxThreadsCount',
        // 'allowedThreadsCount',
        'status'
    ];

    constructor(
        private readonly instanceService: InstanceService,
        private readonly zoningCodeService: ZoningCodeService
    ) {}

    ngOnInit(): void {
        if (this.showActions) {
            this.taskColumnsToDisplay.push('actions');
        }
    }

    getInstanceName(task: ITaskModel) {
        const instance = this.instanceService.getInstanceById(task.instanceId);
        return _.get(instance, 'Name');
    }

    getZoningCodeName(task: ITaskModel) {
        const zc = this.zoningCodeService.getZoningCodeById(task.zoningCodeId);
        return zc ? zc.Name : '';
    }

    // getThreadsTitle() {
    //     return `Current Threads (${this.totalActiveThreadsCount})`;
    // }
}
